module.exports = __webpack_public_path__ + "static/img/oracle-square.b678af7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/oracle-square.svg
// module id = hVU8
// module chunks = 134